export default class Tab {
  constructor() {
    this.tabTgt = document.querySelectorAll(".p-top__event__nav__list");
    this.tabBody = document.querySelectorAll(".p-top__event__body");
    this.init();
  }

  init() {
    this.tabTgt.forEach((element) => {
      const tgtId = element.dataset.tabTgt;

      element.addEventListener(
        "click",
        () => {
          this.tabTgt.forEach((tab) => {
            tab.classList.remove("is-active");
          });
          this.tabBody.forEach((tab) => {
            tab.classList.remove("is-active");
          });
          const tab = document.querySelector(`[data-tab-body="${tgtId}"]`);
          const tgt = document.querySelector(`[data-tab-tgt="${tgtId}"]`);
          tgt.classList.add("is-active");
          tab.classList.add("is-active");
        },
        false
      );
    });
  }
}
